// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__38Qa0","header":"PatientBlock_header__36T5A","label":"PatientBlock_label__Y0BYR","option":"PatientBlock_option__3Z3nv"};